import React from 'react';
import { Link } from 'react-router-dom';

const ServiceCard = ({ title, description, image, link, linkLabel }) => {
    return (
        <div className="group relative overflow-hidden rounded-xl shadow-lg bg-white hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
            {/* Image Container */}
            <div className="relative h-64 overflow-hidden">
                <img
                    src={image}
                    alt={title}
                    className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-80 group-hover:opacity-90 transition-opacity"></div>
            </div>

            {/* Content */}
            <div className="absolute bottom-0 left-0 w-full p-6 text-white">
                <h3 className="text-2xl font-bold mb-2">{title}</h3>
                <p className="text-gray-200 text-sm mb-4 opacity-0 group-hover:opacity-100 transform translate-y-4 group-hover:translate-y-0 transition-all duration-300">
                    {description}
                </p>
                <Link
                    to={link}
                    className="inline-block text-sm font-semibold text-white border-b-2 border-blue-500 pb-1 hover:text-blue-400 transition-colors"
                >
                    {linkLabel} &rarr;
                </Link>
            </div>
        </div>
    );
};

export default ServiceCard;
